<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
  <g>
    <path d="M295.63,139.77,235.7,79.84A15,15,0,0,0,214.53,101l49.31,49.31-49.37,49.37a15,15,0,0,0,0,21.18c4.6,4.6,16,5.19,21.17,0l59.93-59.93a14.94,14.94,0,0,0,.06-21.18Z"/>
    <path d="M85.88,79.81a15,15,0,0,0-21.17,0l-60,59.93a15,15,0,0,0,0,21.17l59.93,60c5.19,5.19,16.58,4.6,21.18,0a15,15,0,0,0,0-21.18L36.52,150.41,85.89,101a15.05,15.05,0,0,0,0-21.23Z"/>
    <path d="M192.11,15.93a14.91,14.91,0,0,0-18.75,9.85L98.45,265.49c-2.48,7.9,1.83,16.57,9.85,18.76,8.55,2.3,16.75-3.43,18.75-9.85L202,34.69A15,15,0,0,0,192.11,15.93Z"/>
  </g>
</svg>
